
/**
 * SetupHttp — kaynak-referans `app/SetupHttp.ts` karşılığı (2026-07-25 FIX).
 *
 * KÖK-NEDEN NOTU: kaynak-referanstan portlanan komut katmanının tamamı
 * (`features/platform/transport/RestTransport` üzerindeki `http` —
 * ReadStates ack, ChannelCommands, FavoriteGif, Connection, MFA...)
 * `http.installAuth(...)` HİÇ ÇAĞRILMADIĞI için Authorization başlıksız
 * istek atıyordu → `POST /read-states/ack 401` (okundu bilgisi sunucuya
 * hiç yazılamıyor; kırmızı "YENİ" ayracı + kanal/rail rozeti yenilemede ve
 * ikinci cihazda "okunmamış" olarak geri geliyordu — kullanıcı bug-raporu).
 *
 * kaynak-referans index.tsx:176 `setupHttp()` → `http.installAuth(() =>
 * SessionManager.token)` (kaynak-referans API'si HAM token başlığı kabul eder).
 * TEBHOS API'si `Bearer ${token}` bekler (lib/api/client.ts:303 ile aynı
 * format) — RestTransport provider çıktısını olduğu gibi bastığından Bearer
 * öneki BURADA eklenir. Token kaynağı ana client'la aynı tek-kasa
 * (AccountManagerStore erişim-token'ı, getAuthToken delegesi).
 */

import {getAuthToken} from '@app/features/auth/state/AuthenticationStore';
import {http} from '@app/features/platform/transport/RestTransport';

export function setupHttp(): void {
	http.installAuth(() => {
		const token = getAuthToken();
		return token ? `Bearer ${token}` : null;
	});
}
